const suits = { s: "♠️", c: "♣️", d: "♦️", h: "♥️" };
const ranks = [
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "J",
  "Q",
  "K",
  "A",
];
export default function Card({ card }) {
  return (
    <div className="Card">
      <div>{ranks[card[0]]}</div> <div>{suits[card[1]]}</div>
    </div>
  );
}
